import { render, staticRenderFns } from "./requestsList.vue?vue&type=template&id=11843da2&scoped=true"
import script from "./requestsList.vue?vue&type=script&lang=js"
export * from "./requestsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11843da2",
  null
  
)

export default component.exports